import { RefObject, useEffect } from 'react';
import { ShortcutCombo, createShortcutHandler } from '@ifixit/utils';

/**
 * React hook to set up a keyboard shortcut for an input element.
 *
 * @param shortcut ShortcutCombo or predicate function
 * @param inputRef Ref to the input element
 * @param callback Callback to run when shortcut is triggered
 */
export function useShortcut(
   shortcut: ShortcutCombo | ((event: KeyboardEvent) => boolean),
   inputRef: RefObject<HTMLInputElement | null>,
   callback: (input: HTMLInputElement, event: KeyboardEvent) => void
) {
   useEffect(() => {
      if (typeof shortcut !== 'function' && (!shortcut || !shortcut.key)) {
         return;
      }
      const inputElement = inputRef.current;
      if (!inputElement) {
         return;
      }

      const handler = createShortcutHandler(shortcut, inputElement, callback);
      document.addEventListener('keydown', handler, true);

      return () => {
         document.removeEventListener('keydown', handler, true);
      };
   }, [shortcut, inputRef, callback]);
}
